<template>
 <div class="card border-0">
     <div class="row justify-content-center ">
         <div class="col-md-12 pt-3">
             <p class="font-weight-bold pl-3 mb-4 sb-block-title">Login Info</p>
         </div>
     </div>
     <div class="row justify-content-center pl-4 pr-4 pb-2">
         <div class="col-md-12" id="user-form">
             <div class="form-group row">
                 <label for="email" class="col-sm-4 col-form-label">Email</label>
                 <div class="col-sm-8">
                     <input type="text" class="form-control" id="email" name="email" v-model="u.email">
                 </div>
             </div>
             <div class="form-group row">
                 <label for="username" class="col-sm-4 col-form-label">Username</label>
                 <div class="col-sm-8">
                     <input type="text" required class="form-control" id="username" name="username" autocomplete="off" v-model="u.username">
                 </div>
             </div>
             <div class="form-group row">
                 <label for="inputPassword" class="col-sm-4 col-form-label">Password</label>
                 <div class="col-sm-8">
                     <input type="password" class="form-control" name="password" id="inputPassword" autocomplete="off" placeholder="Password" v-model="u.password">
                     <small class="text-muted">Minimum of 8 characters, must contain at least one uppercase, one lowercase, one number, and one symbol.</small>
                 </div>
             </div>
             <div class="form-group row">
                 <label for="password-confirm" class="col-sm-4 col-form-label">Confirm Password</label>
                 <div class="col-md-8">
                     <input id="password-confirm" type="password" placeholder="Confirm Password" class="form-control" name="password_confirmation" v-model="u.password_confirmation" required autocomplete="off">
                 </div>
             </div>
             <div class="form-group row mb-0">
                 <button type="button" class="btn btn-primary" @click="updateUser">Update</button>
             </div>

         </div>
     </div>
 </div>
</template>

<script>
    export default {
        props:['user'],
        mounted() {

        },
        created: function() {

        },
        data(){
            return {
                route: '/api/user',
                u:this.user
            }
        },
        methods:{

            updateUser(){
                this.$http.put(this.route, this.u)
                    .then(function(response) {
                        $('.has-error').removeClass('has-error')
                        $('.help-block').remove()
                        this.$notify({
                            type:'success',
                            title: 'Success',
                            text: 'Login Information was updated!'
                        });
                        this.showModal=false;
                    }, (response) => {
                        this._handleErrors(response.data, '#user-form')
                    })
            },
            _handleErrors: function(items, selector)
            {
                $('.has-error').removeClass('has-error')
                $('.help-block').remove()

                for (var error in items['errors']) {
                    if (items['errors'].hasOwnProperty(error)) {
                        var text = error;
                        var parts = text.split('.');
                        var name = parts.pop();
                        var el = $(selector + ' [name="'+name+'"]')
                        el.closest('.form-group').addClass('has-error')
                        $( '<p class="help-block">'+(items['errors'][error].join(', '))+'</p>' ).insertAfter(selector + ' [name="'+name+'"]');
                    }
                }
            }
        }

    }
</script>
